module.exports = __webpack_public_path__ + "media/images/core_values/open_mindedness-489d9368aeb21740be0354319eb4f446.png";